import { IconButton, LuIcon } from "@overmap-ai/blocks"
import { useEditorState } from "@tiptap/react"
import { type ComponentPropsWithRef, memo, type MouseEventHandler, useCallback } from "react"

import { useFallbackEditor } from "../../hooks"
import { tipTapIconMapping } from "../mappings"
import type { OptionalEditorProps } from "../typings"

interface UnsetMarksButtonProps
	extends Omit<ComponentPropsWithRef<typeof IconButton>, "children" | "disabled">, OptionalEditorProps {}

export const UnsetMarksButton = memo<UnsetMarksButtonProps>((props) => {
	const { ref, onClick, editor: editorFromProps, ...rest } = props

	const editor = useFallbackEditor(editorFromProps)

	const state = useEditorState({
		editor,
		selector: () => {
			return {
				disabled: !editor?.can().chain().focus().unsetAllMarks().run(),
			}
		},
	})

	const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
		(e) => {
			onClick?.(e)
			if (e.defaultPrevented) return
			editor?.chain().focus().unsetAllMarks().unsetTextAlign().run()
		},
		[editor, onClick],
	)

	return (
		<IconButton ref={ref} onClick={handleClick} disabled={state.disabled} {...rest}>
			<LuIcon icon={tipTapIconMapping.unsetMarks} />
		</IconButton>
	)
})
UnsetMarksButton.displayName = "UnsetMarksButton"
